export const getSearchParamFromUrl = (property: string) => {
  const params = new URL(document.location.href).searchParams;
  return params.get(property) || undefined;
};
